module.exports = __webpack_public_path__ + "static/img/teens_physicalAbuse.13114e27.png";